/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of patdocss (patients) to display or load patdocss */


(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('reflist', {
      restrict: 'E',
      bindings: {
        consultid: '<?'
      },
      template: `
 <div ng-show="vm.referrals.length === 0" class="alert alert-info"><h4>Es wurden noch keine Überweisungen angelegt.</h4></div>
        <div ng-show="vm.referrals.length > 0">
        <h2>Bestehende Überweisungen</h2>
        <div ng-repeat="ref in vm.referrals">
          <div class="row">
            <div class="col-sm-11"><h4>Überweisung</h4></div>
            <div class="col-sm-1">
              <button class="btn btn-danger" ng-click="vm.removeReferral(ref)" uib-tooltip="Überweisung löschen">
                <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
        
          <div class="row">
            <div class="col-xs-12">
              <dl class="dl-horizontal">
                <dt>An/zu</dt>
                <dd>{{ref.to}}{{ref.doctor.fname}}</dd>
                <dt>Diagnose</dt>
                <dd ng-bind="ref.diag"></dd>
                <dt ng-hide="ref.labvalues.length > 0">Erbeten</dt>
                <dd ng-hide="ref.labvalues.length > 0" ng-model="ref.ref">{{ref.ref}}</dd>
                <dt ng-show="ref.cleangroups.length > 0">Laborwerte</dt>
                <dd ng-show="ref.cleangroups.length > 0"><div
                    ng-repeat="grp in ref.cleangroups">{{grp.name}}: <span ng-repeat="val in grp.values"> {{val}}{{$last ? '' : ', '}}</span></div></dd>
                <dt ng-show="ref.biolabels.length > 0">Biopsien</dt>
                <dd ng-show="ref.biolabels.length > 0">
                  <div ng-repeat="label in ref.biolabels">{{label}}</div>
                  </dd>
                <dt>Datum</dt>
                <dd ng-bind="ref.refdate"></dd>
              </dl>
            </div>
          </div>
        </div>
        
        <!-- PDF Vorschau -->
        <a class="btn btn-info" target="_blank" ng-show="vm.referrals.length"
           href="{{vm.previewurl}}">
          <i class="fa fa-eye"></i> PDF Vorschau
        </a>
        <div style="min-height:3cm">&nbsp;</div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Patdocs', 'PatdocsHelper', 'vertxEventBusService', 'PrintHelper',
        function ($log, $http, Rlog, Patdocs, PatdocsHelper, vertxEventBusService, PrintHelper) {
          let vm = this;
          vm.removeReferral = removeReferral;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.patdocss)) {
              vm.patdocss = Patdocs.$search();
            }
          }; // $onInit()

          // vm.consultid might be late propagating, get consult on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue)) {
                vm.consultid = changes.consultid.currentValue;
                Patdocs.$search({consultid: vm.consultid, active: true, type: 'referral'}).$then(function (referrals) {
                  vm.referrals = referrals;
                  if(referrals.length > 0) {
                    vm.previewurl = PrintHelper.referralPreviewUrl(referrals[0].patientid, vm.consultid);
                    $log.debug('ref preview url', vm.previewurl);
                  }

                }, function (err) {
                  $log.error('referrals lookup failed: ', vm.consultid);
                  Rlog.error('patdocs', 'reflist', 'referral lookup failed', {consultid: vm.consultid});
                });
              }
            }
          };

          function removeReferral(ref) {
            ref.active = false;
            ref.$save();
          }
          
          vertxEventBusService.on('patdocs.update', function (message) {
            vm.referrals.$refresh().$then(function (referrals) {
              vm.previewurl = PrintHelper.referralPreviewUrl(referrals[0].patientid, vm.consultid);
              $log.debug('debug: reflist refreshed patdocss');
            }, function (error) {
              $log.debug('debug: reflist refresh patdocs failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());